import axios from "../config";

export const getInfo = (token: string) => {
  return axios.get("/users", {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });
};

export const getAllUsers = (
  token: string,
  limit: any,
  offset: any,
  order: any,
  search: string,
  active: number,
  sector?: any
) => {
  return axios.get(
    `/users/all?offset=${offset}&limit=${limit}&order=${order[0]}&order=${
      order[1]
    }&active=${active}&search=${search}&sector=${sector ? sector : ""}`,
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getUserById = (token: string, id: number) => {
  return axios.get(`/users/${id}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });
};

export const updateUser = (token: string, user: any, userId?: number) => {
  return axios.put(`/users${userId ? `?userId=${userId}` : ""}`, user, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });
};

export const createUser = (token: string, user: any) => {
  return axios.post("/users", user, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });
};

export const patchLanguage = (token: string, language: any) => {
  return axios.patch(
    "/users/language",
    { idioma: language },
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getAllUsersTypes = (token: string, active?: any) => {
  return axios.get(`/users/types${active ? `?ativo=${active}` : ""}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });
};
